import useCurrentUser from '../queries/currentUser/useCurrentUser'

const useCurrentUserInstitutionIdSelector = () => useCurrentUser()?.data?.institution?.replace('/api/groups/', '')

export default useCurrentUserInstitutionIdSelector
